<template ref="body">
  <LoaderComponent
    style="background: white; position: relative"
    v-if="ifQuiz()"
  />
  <div v-else :class="getClassQuizPage()" ref="quizPage">
    <main :class="getClassMain()">
      <LeftQuizPart
        v-if="isQuizLoaded"
        :metricIds="metricIds"
        :sectionRightPart="sectionRightPart"
        :leftPartHeight="leftPartHeight"
        @sendSectionLeftPart="sendSectionLeftPart"
        ref="leftPart"
      />
      <span
        :class="style.blackout"
        v-if="ifBlackout()"
        @click="refLeftPart?.closeContactModal"
      />
      <RightQuizPart
        v-if="isQuizLoaded && sectionLeftPart"
        :leftPartHeight="leftPartHeight"
        :leftPartRef="sectionLeftPart"
        @leftPartHeightChange="leftPartHeightChange"
        @sendSectionRightPart="sendSectionRightPart"
        ref="sectionRightPart"
      />
    </main>
  </div>
  <WidgetComponent v-if="quiz?.widgetInQuiz" />
  <CustomScript v-if="quiz?.customScript" :html="quiz.customScript" />
</template>

<script lang="ts">
import WidgetComponent from "@/widget/WidgetComponent.vue";
import style from "./Quiz.module.scss";
import {insertNonBreakingSpaces} from "@/scripts/typographer";
import LoaderTextButton from "@/elements/loaderTextButton/LoaderTextButton.vue";
import LeftQuizPart from "./components/sections/LeftPart/LeftPart.vue";
import RightQuizPart from "./components/sections/RightPart/RightPart.vue";
import {modifyQuiz} from "../scriptQuiz";
import {defineComponent} from "vue";
import CustomScript from "./components/customScript/customScript.vue";
import {metricIntegration} from "@/page/setting/integration/IntegrationTypes";
import LoaderComponent from "@/elements/UI/overlay/Loader/LoaderComponent.vue";
import {API} from "@/api/generated";

type LeftQuizPartInstance = InstanceType<typeof LeftQuizPart>;

export default defineComponent({
  name: "QuizPage",
  components: {
    LoaderComponent,
    RightQuizPart,
    LeftQuizPart,
    LoaderTextButton,
    WidgetComponent,
    CustomScript
  },
  data() {
    return {
      insertNonBreakingSpaces,
      metricIds: [] as metricIntegration[],
      style,
      mainHeight: 0,
      leftPartHeight: 0,
      sectionRightPart: undefined as HTMLElement[] | undefined,
      sectionLeftPart: null as HTMLElement | HTMLElement[] | null,
      modifyQuiz
    };
  },
  created() {
    this.$quizStore.initMobileVersion();
  },
  mounted() {
    const id = this.$route.params.id;
    if (!Array.isArray(id)) {
      this.setData(id);
    }
  },
  methods: {
    sendSectionLeftPart(value: HTMLElement | HTMLElement[] | null) {
      this.sectionLeftPart = value;
    },
    sendSectionRightPart(value: HTMLElement[] | undefined) {
      this.sectionRightPart = value;
    },
    ifQuiz() {
      if (this.quiz._id == "") {
        return true;
      }
      if (this.mobileVersion && this.quiz) {
        return (
          !this.quiz.mobileVersionQuiz ||
          JSON.stringify(this.quiz.mobileVersionQuiz) == "{}"
        );
      }
      return false;
    },
    ifBlackout() {
      return (
        (!this.startPage && this.mobileVersion && this.onlyFormBool) ||
        (!this.startPage && !this.mobileVersion)
      );
    },
    getClassQuizPage() {
      let classItem = this.style.quizPage;
      if (this.mobileVersion) {
        classItem += " " + this.style.mobile;
      } else {
        classItem += " " + this.style.pc;
      }
      return classItem;
    },
    getClassMain() {
      let style = this.style.oldVersion;
      let rightSectionList = this.modifyQuiz("get", "", ["rightSectionList"]);
      if (rightSectionList && rightSectionList?.length != 0) {
        style += " " + this.style.newVersion;
      }
      return style;
    },
    async getMetricIntegrationKey() {
      try {
        return (await API.getMetric({query: {id: this.quiz.userId}})) || [];
      } catch {
        console.error("ошибка получения id счётчиков метрики");
        return [];
      }
    },
    async setData(id: string) {
      await this.$quizStore.fetchQuiz([id, false]);
      document.title =
        this.quiz.nameHeaderSite ?? "Readds - сервис онлайн записи для клиник";
      this.metricIds = await this.getMetricIntegrationKey();

      this.metricIds.push({id: "106353501"});
    },
    autoFocusFirstInput() {
      setTimeout(() => {
        let questionListBlok = document.querySelectorAll<HTMLElement>(
          "." + this.style.questionList
        );
        let questionItem = Array.from(questionListBlok).filter((item) => {
          return item.style.display != "none";
        })[0];
        if (!questionListBlok) {
          return;
        }
        let firstInput = questionItem.querySelector("input");
        if (firstInput?.type != "radio" && firstInput?.type != "checkbox") {
          firstInput?.focus();
        }
        window.scrollTo({top: -100, behavior: "smooth"});
      }, 10);
    },
    leftPartHeightChange(value: number) {
      this.leftPartHeight = value;
    }
  },
  computed: {
    quiz() {
      return this.$quizStore.getQuiz;
    },
    isQuizLoaded(): boolean {
      return this.quiz._id != "";
    },
    mobileVersion() {
      return this.$quizStore.getMobileVersion;
    },
    onlyFormBool() {
      return this.modifyQuiz("get", "", ["onlyFormBool"]);
    },
    refLeftPart(): LeftQuizPartInstance | null {
      return this.$refs.leftPart as LeftQuizPartInstance | null;
    },
    startPage() {
      return this.$quizStore.getStartPage;
    }
  }
});
</script>
